jQuery(function ($) {

    var fe_path = '../img/glamb-chiitan';
    var sp_fe_path = '../img/sp/glamb-chiitan';
    var is_visual_set = false;
    var ww = function () { var v = (window.innerWidth) ? window.innerWidth : $(window).width(); return v; };
    var wh = function () { var v = (window.innerHeight) ? window.innerHeight : $(window).height(); return v; };

    $.fn.extend({
        // page scroll animation
        featurePS: function (options) {
            var defaults = {
                speed: 300
            };
            var op = $.extend(defaults, options);
            var $t = $(this);
            $t.off('click');
            $t.on('click', function () {
                var Hash = $(this).attr('href');
                if ($(Hash).length) {
                    var HashOffset = (Hash == '#top') ? 0 : $(Hash).offset().top;
                    $('html:not(:animated),body:not(:animated)').animate({ scrollTop: HashOffset + 'px' }, op.speed);
                };
                return false;
            });
        },
        // page top display
        featurePageTop: function (options) {
            var defaults = {
                speed: 200
            };
            var op = $.extend(defaults, options);
            var $t = $(this);
            var $contents = $('#contents');
            var bool = {
                scrolling: true
            };
            var set = function () {
                var st_h = GN.st() + GN.wh();
                var contents = {
                    top: $contents.offset().top,
                    h: $contents.innerHeight()
                };
                var limit = GN.wh() + 100;
                if (st_h > (contents.top + contents.h + 60)) {
                    $t.show().css({ position: 'absolute', bottom: '0' });
                    bool.scrolling = true;
                } else if (GN.st() >= limit && bool.scrolling) {
                    bool.scrolling = false;
                    $t.css({ position: 'fixed', bottom: '20px' }).stop(false, false).fadeIn(op.speed);
                } else if (GN.st() < limit && !bool.scrolling) {
                    $t.stop(false, false).fadeOut(op.speed, function () {
                        bool.scrolling = true;
                    });
                };
            };
            set();
            $(window).on({
                'load scroll touchmove': function () { set(); }
            });
            $t.find('a').featurePS();
        },
        // visual animation
        featureVisualAnimation: function (options) {
            var defaults = {
                len: 7,
                bg: sp_fe_path + '/top_visual1.jpg',
                file: fe_path + '/top_visual_item'
            };
            var op = $.extend(defaults, options);
            var $t = $(this);
            var $bg = $t.find('.bg');
            var $bg_stay = $t.find('.bg_stay');
            var $items = $('<ul class="items" />');
            var $header = $('#fe_header');
            var $contents = $('#contents');
            var arr = {
                item: [],
                appear: []
            };
        },
        // feature header
        featureHead: function (options) {
            var defaults = {
                speed: 400,
            };
            var op = $.extend(defaults, options);
            var $t = $(this);
            var $menu = $t.find('.btn_menu a');
            var $gnav = $t.find('#fe_gnav');
            var $contents = $('#contents');
            var $parallax = $('#parallax');
            var headVisible = function () {
                if (GN.st() >= $contents.offset().top && !$parallax.hasClass('visible')) {
                    // $t.addClass('visible');
                    $parallax.addClass('visible');
                } else if (GN.st() < $contents.offset().top && $parallax.hasClass('visible')) {
                    // $t.removeClass('visible');
                    $parallax.removeClass('visible');
                };
            };
            var menuClose = function () {
                $menu.removeClass('on');
                $gnav.fadeOut(op.speed);
                $('body').off('touchmove');
                $gnav.off('touchmove');
                $gnav.find('.frame').height('auto').off('touchmove');
            };

            $menu.off('click');
            $menu.on('click', function () {
                if ($gnav.is(':hidden')) {
                    $menu.addClass('on');
                    $gnav.fadeIn(op.speed);
                    $('body').on('touchmove', function (e) { e.preventDefault(); });
                    $gnav.on('touchmove', function (e) { e.preventDefault(); });
                    if (wh() < $gnav.find('.frame').innerHeight()) {
                        $gnav.find('.frame').height(wh()).on('touchmove', function (e) { e.stopPropagation(); });
                    };
                } else {
                    menuClose();
                };
                return false;
            });

            $gnav.find('.close a').off('click');
            $gnav.find('.close a').on('click', function () {
                menuClose();
                return false;
            });

            $gnav.find('.item_list ul li').each(function () {
                $(this).find('a').featurePS();
                $(this).find('a').on('click', function () {
                    menuClose();
                    return false;
                });
            });

            $(window).on({
                'load scroll touchmove': function () {
                    headVisible();
                }
            });

        }
    });
    $('.top_visual_scroll a').featurePS();
    $('#top_visual').featureVisualAnimation();
    $('#fe_header').featureHead();
    $('#fe_pagetop').featurePageTop();
});




$(function () {
    var $slider_container = $('.slider-container'),
        $slider = $('.slider');
    $slider.each(function (index) {
        $slider.eq(index).slick({
            adaptiveHeight: true,
        });
    });
});

$(window).load(function () {
    $('.slider-container').each(function () {
        $(this).find('ul.slider li').tile();
    });
});


/* models
------------------------------------------------ */
$(function () {
    $('.model_list').each(function (index) {
        var $more_btn = $('#models .more_btn');
        var $close_btn = $('#models .close_btn');
        $more_btn.on('click', function () {
            $(this).prev('.close_btn').show();
            $(this).hide();
        });
        $close_btn.on('click', function () {
            $(this).next('.more_btn').show();
            $(this).hide();
        });
        return false;
    });
});



/* all item
------------------------------------------------ */

$(function () {
    var $move_container = $('.move_container');
    $('.move').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        // dots: true,
        infinite: true,
        autoplay: false,
        arrows: false,
        centerMode: true,
        centerPadding: '14%',

    });
});

